<template>
    <cell
        :background="'bg-gray-100 dark:bg-gray-600'"
        class="space-x-2 z-30 sticky top-0"
    >
        <slot name="title"><span>{{ $t('general.entries') }}</span></slot>

        <template v-if="hasCategories">
            <default-button
                :label="$t('storemanager.open-all-categories')"
                icon="folder-open"
                size="xxs"
                @click.native="setCategoriesOpen(true)"
            ></default-button>
            <default-button
                :label="$t('storemanager.close-all-categories')"
                icon="folder"
                size="xxs"
                @click.native="setCategoriesOpen(false)"
            ></default-button>
        </template>

        <slot name="actions"></slot>
    </cell>
</template>

<script>
import Cell from '@/Components/Storemanager/InitialColumn/Cell';

export default {
    components: {Cell},

    props: {
        hasCategories: {
            type: Boolean,
            required: true,
        },
    },

    methods: {
        setCategoriesOpen(status) {
            this.$emit('update:categories-open', status);
        },
    },
};
</script>
